export const MOCK_SERVER_STORAGE_KEY = "mock-server-config"

export const API_KEY_HEADER = "x-api-key"
export const MOCK_RESPONSE_HEADER = "x-mock-response"

export const SERVICE_ROUTE_REQUESTS_PATH = "_service-route/requests"
